angular.module('smartorg.r6.mgmts.groupManage').directive('groupManagement', ["$timeout", function ($timeout) {
        return {
            restrict: 'E',
            template: require('../../template/group-manage.html'),
            scope: {
                astro: '=?',
                showAlert: '&?'
            },
            link: function (scope) {
                /**
                 * Wrap the showAlert function to a easier call.
                 *
                 * @param type
                 * @param title
                 * @param message
                 */
                var showMessage = function (type, title, message) {
                    scope.showAlert({
                        type: type,
                        title: title,
                        message: message
                    });
                };
                /**
                 * Wrap angular apply thingy.
                 */
                var applyChange = function () {
                    setTimeout(function () {
                        scope.$apply();
                    });
                };
                // Create a alert method if not passed in.
                if (!scope.showAlert) {
                    scope.showAlert = function (input) {
                        alert(input.message);
                    };
                }
                // Check api status
                if (!scope.astro) {
                    showMessage('danger', 'System Error', 'Failed to load API.');
                }
                scope.group = {
                    /**
                     * Current selected group. This is the key.
                     */
                    selected: undefined,
                    /**
                     * Editing group. Use for create/edit node.
                     */
                    editing: {},
                    /**
                     * Search keyword for group.
                     */
                    filterKey: '',
                    /**
                     * List of groups which contains names, descriptions
                     * and users.
                     */
                    list: [],
                    /**
                     * Load group list from server through api.
                     */
                    load: function () {
                        scope.astro.getListOfGroups().then(function (groups) {
                            scope.group.list = groups.sort(function (prev, next) {
                                var a = prev.groupname.toLowerCase();
                                var b = next.groupname.toLowerCase();
                                return a === b ? 0 : a > b ? 1 : -1;
                            });
                            setTimeout(function () {
                                var windowHeight = window.innerHeight;
                                var listEle = $("#groupList");
                                scope.groupListHeight = windowHeight -
                                    listEle.offset().top - 90;
                                scope.$apply();
                            });
                        })["catch"](function (err) {
                            showMessage('danger', "Server Error " + err.status, err.message);
                        });
                    },
                    /**
                     * Select a group through click evernt. On selecting
                     * group, go through the user list to label if a user
                     * belong to the selected group.
                     *
                     * @param gp {{}} Group object from the list.
                     */
                    select: function (gp) {
                        scope.group.selected = gp;
                        scope.user.showall = false;
                        if (scope.user.list) {
                            scope.user.list.forEach(function (ur) {
                                ur.ingroup = gp.users.indexOf(ur._id) > -1;
                            });
                            // Calculate height for the user list.
                            setTimeout(function () {
                                var windowHeight = window.innerHeight;
                                var listEle = $("#groupUserList");
                                scope.userListHeight = windowHeight -
                                    listEle.offset().top - 25;
                                scope.$apply();
                            });
                        }
                    },
                    /**
                     * Show edit modal and create a copy of selected group.
                     */
                    showEditBox: function () {
                        scope.group.editing = JSON.parse(JSON.stringify(scope.group.selected));
                        $("#groupManageModal").modal("show");
                    },
                    /**
                     * Show create new node modal and clean up the editing
                     * object.
                     */
                    showCreateBox: function () {
                        scope.group.editing = {
                            groupname: "",
                            description: "",
                            downloadModel: false
                        };
                        $("#groupManageModal").modal("show");
                    },
                    /**
                     * Save group to server. If edit object has an id, that
                     * means it is a existing node and call the edit.
                     *
                     * Otherwise call the create function.
                     */
                    saveGroup: function () {
                        if (scope.group.editing._id) {
                            scope.astro.editGroup(scope.group.editing._id, scope.group.editing.groupname, scope.group.editing.description, scope.group.editing.downloadModel).then(function () {
                                scope.group.selected.groupname = scope.group.editing.groupname;
                                scope.group.selected.description = scope.group.editing.description;
                                scope.group.selected.downloadModel = scope.group.editing.downloadModel;
                                $timeout();
                                $("#groupManageModal").modal("hide");
                                scope.loadData();
                            })["catch"](function (err) {
                                showMessage('danger', "Server Error " + err.status, err.message);
                            });
                        }
                        else {
                            scope.astro.createNewGroup(scope.group.editing.groupname, scope.group.editing.description, scope.group.editing.downloadModel).then(function () {
                                $("#groupManageModal").modal("hide");
                                scope.loadData();
                            })["catch"](function (err) {
                                showMessage('danger', "Server Error " + err.status, err.message);
                            });
                        }
                    },
                    /**
                     * Delete current selected group. First pop out a
                     * confirm dialog. Delete group after confirm.
                     */
                    deleteSelected: function () {
                        bootbox.dialog({
                            message: "Delete group <b>" + scope.group.selected.groupname + "?</b>",
                            title: "Confirm Deletion",
                            buttons: {
                                confirm: {
                                    label: "Delete",
                                    className: "btn-danger",
                                    callback: function () {
                                        scope.astro.deleteGroup(scope.group.selected._id).then(function () {
                                            scope.group.selected = undefined;
                                            scope.loadData();
                                        })["catch"](function (err) {
                                            showMessage('danger', "Server Error " + err.status, err.message);
                                        });
                                    }
                                },
                                cancel: {
                                    label: "Cancel",
                                    className: "btn-primary"
                                }
                            }
                        });
                    },
                    /**
                     * Filter for group name searching.
                     *
                     * @param item
                     * @returns {boolean}
                     */
                    filter: function (item) {
                        return item.groupname.toLowerCase().indexOf(scope.group.filterKey.toLowerCase()) > -1;
                    },
                    /**
                     * Add a user to selected group.
                     *
                     * @param user {{}} User object, should at least has
                     *     user id.
                     */
                    addUserToSelected: function (user) {
                        if (scope.group.selected && scope.group.selected.users) {
                            scope.astro.groupAddUser(scope.group.selected._id, user._id).then(function () {
                                scope.group.selected.users.push(user._id);
                                user.ingroup = true;
                                applyChange();
                            })["catch"](function (err) {
                                showMessage('danger', "Server Error " + err.status, err.message);
                            });
                        }
                        else {
                            alert("ERROR");
                        }
                    },
                    /**
                     * Remove a user from selected group.
                     *
                     * @param user {{}} User object, should at least has
                     *     user id.
                     */
                    removeUserFromSelected: function (user) {
                        if (scope.group.selected && scope.group.selected.users) {
                            scope.astro.groupRemoveUser(scope.group.selected._id, user._id).then(function () {
                                var index = scope.group.selected.users.indexOf(user._id);
                                scope.group.selected.users.splice(index, 1);
                                user.ingroup = false;
                                applyChange();
                            })["catch"](function (err) {
                                showMessage('danger', "Server Error " + err.status, err.message);
                            });
                        }
                        else {
                            alert("ERROR");
                        }
                    }
                };
                scope.user = {
                    /**
                     * List of users.
                     */
                    list: [],
                    /**
                     * Keyword for user searching.
                     */
                    filterKey: "",
                    /**
                     * Filter for user searching.
                     * @param item
                     * @returns {boolean|any}
                     */
                    filter: function (item) {
                        var k = scope.user.filterKey.toLowerCase();
                        var a = item.username.toLowerCase().indexOf(k) > -1;
                        var b = item.name &&
                            item.name.toLowerCase().indexOf(k) > -1;
                        return a || b;
                    },
                    /**
                     * Toggle group member management. That is, show all
                     * user or not.
                     */
                    toggleList: function () {
                        scope.user.showall = !scope.user.showall;
                    },
                    load: function () {
                        scope.astro.getListOfUsers().then(function (users) {
                            scope.user.list = users.sort(function (prev, next) {
                                var a = prev.username.toLowerCase();
                                var b = next.username.toLowerCase();
                                return a === b ? 0 : a > b ? 1 : -1;
                            });
                        })["catch"](function (err) {
                            showMessage('danger', "Server Error " + err.status, err.message);
                        });
                    }
                };
                /**
                 * Load group and user.
                 */
                scope.loadData = function () {
                    scope.group.load();
                    scope.user.load();
                };
                scope.$on('manage:GROUP_INIT', function () {
                    scope.loadData();
                });
                scope.back = function () {
                    scope.$emit('workbench:back');
                };
            }
        };
    }]);
//# sourceMappingURL=group-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/group-manage/app/js/plumbing/group-directive.js